var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06238 16.2988L5.51863 16.5218C6.59363 16.6863 7.36134 17.6488 7.28217 18.7332L7.17488 20.203C7.14363 20.6311 7.37697 21.0343 7.76342 21.2207L8.84051 21.7395C9.22697 21.9259 9.68842 21.8561 10.004 21.5655L11.0863 20.5655C11.8843 19.828 13.1155 19.828 13.9145 20.5655L14.9968 21.5655C15.3124 21.8572 15.7728 21.9259 16.1603 21.7395L17.2395 21.2197C17.6249 21.0343 17.8572 20.6322 17.8259 20.2051L17.7186 18.7332C17.6395 17.6488 18.4072 16.6863 19.4822 16.5218L20.9384 16.2988C21.3624 16.2343 21.704 15.9166 21.7999 15.4978L22.0655 14.3332C22.1613 13.9145 21.9915 13.4801 21.6374 13.2384L20.4218 12.4061C19.5249 11.7916 19.2509 10.5916 19.7926 9.64885L20.527 8.37176C20.7405 7.99989 20.7051 7.53426 20.4374 7.19885L19.6926 6.26447C19.4249 5.92906 18.979 5.79051 18.5686 5.91656L17.1603 6.34781C16.1197 6.66656 15.0103 6.13218 14.6103 5.12072L14.0707 3.75301C13.9124 3.35301 13.5259 3.09051 13.0957 3.09156L11.902 3.09468C11.4718 3.09572 11.0863 3.36031 10.9301 3.76135L10.404 5.11343C10.0082 6.13114 8.89363 6.66968 7.84988 6.34885L6.38322 5.89885C5.97176 5.77176 5.52384 5.91135 5.25613 6.24885L4.51655 7.18426C4.24884 7.52281 4.21655 7.98947 4.43426 8.36135L5.1853 9.64156C5.73842 10.5853 5.46759 11.7968 4.56551 12.4145L3.36447 13.2374C3.0103 13.4801 2.84051 13.9145 2.93634 14.3322L3.20197 15.4968C3.29676 15.9166 3.63842 16.2343 4.06238 16.2988V16.2988Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4957 10.5041C15.5978 11.6061 15.5978 13.3936 14.4957 14.4957C13.3936 15.5978 11.6061 15.5978 10.5041 14.4957C9.40197 13.3936 9.40197 11.6061 10.5041 10.5041C11.6061 9.40197 13.3936 9.40197 14.4957 10.5041",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.6a85b9062909cec45836500ac1f27b9c.svg";
export { ForwardRef as ReactComponent };